import { useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import Link from 'next/link';
import { nanoid } from 'nanoid';
import { useStyles } from './style';

/**
 * @name NavLinks
 * @description Displays footer navigation links
 * @param {*} param0 - Destructured object
 * @param {Array} param0.links - List of links from footer data
 * @returns {JSX.Element} ReactElement
 */
const NavLinks = ({ links }) => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <Stack spacing={1}>
      {links?.map(link =>
        link?.map(data => (
          <Link key={nanoid(8)} underline='hover' component='a' href={data?.link} aria-label={data?.ariaLabel}>
            <Typography sx={style.navLink} variant='subtitle1' component='p'>
              {data?.text}
            </Typography>
          </Link>
        )))}
    </Stack>
  );
};

NavLinks.displayName = 'NavLinks';
export default NavLinks;
